export enum MartkUserNotificationMsg {
    MarkDeleteNone = 0,
    MarkDeleteById = 1,
    MarkAllDeleted = 2,
    MarkReadedNone = 0,
    MarkReadedById = 1,
    MarkAllReaded = 2
}